import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDebounce } from '../hooks/CIDUseDebounce'; // Assumindo que o hook de debounce já está implementado

function CIDSearchInput({ onSearch }) {
  const [inputValue, setInputValue] = useState('');
  const [filterType, setFilterType] = useState('name'); // 'name' ou 'codigo'

  // Debounced input value to avoid triggering search on every key press
  const debouncedSearchTerm = useDebounce(inputValue, 500);

  // Chama o search automaticamente após o usuário parar de digitar
  useEffect(() => {
    if (debouncedSearchTerm) {
      onSearch({ query: debouncedSearchTerm, type: filterType });
    }
  }, [debouncedSearchTerm, filterType, onSearch]);

  // Atualiza o estado do input conforme o usuário digita
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between p-4 bg-gray-100 rounded-lg w-full space-y-4 sm:space-y-0 sm:space-x-4">
      <div className="flex space-x-4 w-full">
        {/* Campo de busca com responsividade */}
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          placeholder={`Buscar pelo ${filterType === 'name' ? 'Nome' : 'Código'}`}
          className="flex-grow p-2 border rounded-md border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-600"
          aria-label={`Buscar pelo ${filterType === 'name' ? 'Nome' : 'Código'}`} // Acessibilidade
        />
        {/* Seleção de filtro (nome/código) */}
        <select
          value={filterType}
          onChange={(e) => setFilterType(e.target.value)}
          className="border border-gray-300 rounded-md p-2 pr-8 focus:ring-green-600 appearance-none"
          aria-label="Selecionar filtro de busca"
        >
          <option value="name">Nome</option>
          <option value="codigo">Código</option>
        </select>
      </div>
      {/* Botão de busca */}
      <div className="ml-0 sm:ml-4">
        <button
          type="button"
          onClick={() => onSearch({ query: inputValue, type: filterType })}
          className="px-4 py-2 text-white rounded-3x1  focus:outline-none focus:ring-2 transition duration-200"
        >
          Buscar
        </button>
      </div>
    </div>
  );
}

CIDSearchInput.propTypes = {
  onSearch: PropTypes.func.isRequired,
};

export default CIDSearchInput;
